import { pr, theme, ui } from "aaa";
import { AppointmentRoutes } from "components/appointment/AppointmentRoutes";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { IconCalendar } from "components/util/primitives";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";


export const ShopCreditCardBusinessAppointmentCard = ({ isMobile, noValidAddress }: { isMobile?: boolean; noValidAddress?: boolean }) => {

    const appointmentTextId = noValidAddress ? "shop.creditCardBusiness.appointment.text.noValidAddress" : "shop.creditCardBusiness.appointment.text.noValidAccount";

    const handleClickMakeAppointment = () => {
        pushRoute(AppointmentRoutes.TOPIC, true);
    };

    return (
        <div style={{ padding: theme.MARGIN }}>
            <pr.P_18_TITLE style={{ lineHeight: "24px", fontWeight: 700 }}>
                {ui.__("shop.creditCardBusiness.appointment.title")}
            </pr.P_18_TITLE>
            <pr.P_16_CONTENT style={{ lineHeight: "24px", marginTop: 8 }}>
                {ui.__(appointmentTextId)}
            </pr.P_16_CONTENT>
            <GdsFakeActionButton
                onClick={handleClickMakeAppointment}
                style={{ display: isMobile ? undefined : "inline-block", borderRadius: 8, marginTop: 16 }}
                innerStyle={{ display: "flex", alignItems: "center", justifyContent: isMobile ? "center" : undefined, gap: 8 }}
            >
                <span>
                    <IconCalendar style={{ width: 24, height: 24, display: "block" }} />
                </span>
                <span>{ui.__("shop.creditCardBusiness.appointment.button")}</span>
            </GdsFakeActionButton>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/shopCreditCardBusiness/components/ShopCreditCardBusinessAppointmentCard.tsx